export class Category {
  constructor(
    public id: number,
    public name: string,
    public breadcrumb?: string,
    public childCategories?: Array<Category>,
    public level?: number,
    public industryCode?: string,
    public parentId?: number
  ) { }
}
